import { Injectable } from '@angular/core';
import { EnrollmentHelper } from '@rd/helpers/enrollment.helper';
import { Enrollment } from '@rd/types';

@Injectable({
  providedIn: 'root',
})
export class AnzEnrollmentHelper extends EnrollmentHelper {
  productTypeFromProductCode(enrollment: Enrollment): string {
    if (!!enrollment.groupName) {
      return enrollment.groupName;
    }

    switch (enrollment.productCode) {
      case '301':
        return 'ANZ Rewards';
      case '304':
        return 'ANZ Rewards Platinum';
      case '308':
        return 'ANZ Rewards Black';
    }

    return 'ANZ card';
  }
}
